// import { MdDone, MdAccessTime, MdDangerous } from "react-icons/md";
import { VscVerified, VscUnverified, VscWarning, VscWatch } from "react-icons/vsc";

export default function KycStatusCompHyper(props) {
    const {
        status = ""
    } = props;
    // console.log('KycStatusComp-----', props)
    return (
        status === 'needs_review'
            ?
            <small className="text-warning text-cap text-capitalize"><VscWatch /> {status}</small>
            :
            (status === 'auto_approved' || status === 'approved' || status === 'manually_approved')
                ?
                <small style={{ color: 'rgb(16, 237, 182)' }} className="text-capitalize"><VscVerified /> {status}</small>
                :
                status === 'auto_declined'
                    ?
                    <small className="text-danger text-capitalize"><VscWarning /> {status}</small>
                    :
                    status === 'user_cancelled' || status === 'Error' || status === 'Not Verified'
                        ?
                        <small className="text-danger text-capitalize"><VscUnverified /> {status}</small>
                        :
                        <></>
    )
};